module.exports = __webpack_public_path__ + "static/a6-f64095eee8f468ac5a0866f6cd8b3d9f.jpg";